import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from '../../core/services/settings.service';


@Injectable({ providedIn: 'root' })
export class UserServices {
    userAccountName: string;

    constructor(private http: HttpClient, private settingsService: SettingsService) { }

    getCountries() {
        return this.http.get(`${this.settingsService.getStoreApiUrl()}getcountries`);
    }

    checkVat(vatNumber: string, country: string) {
        return this.http.get(`${this.settingsService.getStoreApiUrl()}checkvat/${country}/${vatNumber}`);
    }

    public getUserLanguage() {
        const supportedLanguage = ['en', 'it', 'de'];
        let language = '';
        try {
            const lang = window.navigator.language.substring(0, 2);
            if (supportedLanguage.find((p) => p === lang) === undefined) {
                language = 'en';
            } else language = lang;
        } catch (exc) {
            language = 'en';
        }
        switch (language) {
            case 'it':
                language = 'it-IT';
                break;
            case 'de':
                language = 'de-DE';
                break;
            default:
                language = 'en-US';
        }
        return language;
    }
}
